import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const EditTimeIcon = ({
  className = '~w-3.5/4 h-auto',
  fill = COLOR.GRAY['900']
}: IconProps) => {
  const fillColor = isDarkMode() ? COLOR.WHITE : fill;
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      shapeRendering='geometricPrecision'
      textRendering='geometricPrecision'
      imageRendering='optimizeQuality'
      fillRule='evenodd'
      clipRule='evenodd'
      className={className}
      viewBox='0 0 512 406.6'
      fill={fillColor}
    >
      <path d='M334.1 1.64a202.504 202.504 0 0 1 135.16 77.02c68.84 88.6 52.82 216.19-35.78 285.03-.08.05-.14.11-.22.18-88.57 68.82-216.15 52.81-284.97-35.76-.04-.06-.09-.12-.14-.17A204.822 204.822 0 0 1 125.31 291a168.69 168.69 0 0 0 37.79-5.42 172.61 172.61 0 0 0 13.55 20.29c56.7 72.81 161.67 85.86 234.46 29.15 72.8-56.69 85.84-161.66 29.15-234.46-40.28-51.71-107.08-75.09-170.82-59.79a171.08 171.08 0 0 0-21.88-31.29c2.46-.8 4.95-1.51 7.46-2.21 25.77-7.13 52.69-9.03 79.19-5.63h-.11zM0 129.16v-15.4C3.97 50.8 56.26.95 120.21.92h.05c66.58-.01 120.55 53.93 120.59 120.51.03 66.58-53.93 120.56-120.51 120.59C56.33 242.04 3.97 192.17 0 129.16zm113.56 36.47-44.1 11.75 6.35-47.33 37.75 35.58zm-28.02-46.31 46.26-52.34c.73-.86 1.81-1.37 2.9-1.38.7-.02 1.4.13 2.02.46l33.59 30.54c.67.61 1.07 1.5 1.08 2.4.02 1.02-.4 2.02-1.19 2.71l-47.05 53.19-37.68-35.58h.07zm212.08-14.81c1.24-9.88 10.24-16.88 20.09-15.64h.04c9.82 1.32 16.73 10.32 15.46 20.13l-11.7 94.09 65.06 50.55c7.85 6.1 9.3 17.4 3.2 25.28a18.011 18.011 0 0 1-11.95 6.82c-4.73.62-9.51-.68-13.26-3.62l-72.82-56.61a17.818 17.818 0 0 1-5.79-7.08 18.336 18.336 0 0 1-1.46-9.67l13.13-104.2v-.05z' />
    </svg>
  );
};

export default EditTimeIcon;
